import { Component } from '@angular/core';
import {
  COMPANY_LINKS,
  FRAGRANCES_LINKS,
  LINKEDIN_LINK,
  PRIVACY_NOTICE_LINK,
  SUPPORT_LINKS,
} from '@banyan/commons/consts/links.const';
import { SimpleLink } from '@banyan/commons/models/simple-link.model';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent {
  protected readonly PRIVACY_NOTICE_PAGE = PRIVACY_NOTICE_LINK;
  protected readonly LINKEDIN_LINK = LINKEDIN_LINK;
  currentYear: number = new Date().getFullYear();

  companyLinks: SimpleLink[] = COMPANY_LINKS;
  fragrancesLinks: SimpleLink[] = FRAGRANCES_LINKS;
  supportLinks: SimpleLink[] = SUPPORT_LINKS;
}
